import React, { useState } from "react";
import { Badge } from "react-bootstrap";

import classNames from "classnames";

import usePlacementHandlers from "../hooks/usePlacementHandlers";
import { PlacementTeamHeaderProps } from "../types/placement";

import { TEAM_LOGO_URL } from "../../../../../lib/globals";
import { CheckIcon, StarIcon } from "../../../../../lib/icons";
import { AsyncStatuses } from "../../../../../types/shared";

const PlacementTeamHeader = ({
    team,
    ratings,
    setRatings,
}: PlacementTeamHeaderProps): React.JSX.Element => {
    const [updateStatus, setUpdateStatus] = useState<AsyncStatuses>(undefined);
    const [hoveredStars, setHoveredStars] = useState<number>(0);
    const userRating = ratings.find(r => r.team === team.id);
    const { handleStarClick } = usePlacementHandlers({
        setRatings,
        setUpdateStatus,
    });

    return (
        <div className="placementHeader" data-testid="placementHeader">
            {team.logo && (
                <img
                    src={`${TEAM_LOGO_URL}${team.logo}`}
                    alt={`${team.name} logo`}
                    className="teamLogo"
                />
            )}
            <h2>{team.name}</h2>
            <div className="stars">
                <Badge
                    bg={
                        updateStatus === "success"
                            ? "success"
                            : updateStatus === "failed"
                              ? "danger"
                              : "info"
                    }
                    className={classNames({
                        hidden: updateStatus !== "success",
                        visible: updateStatus === "success",
                    })}
                >
                    <CheckIcon />
                    {updateStatus === "success" && "Changes saved"}
                </Badge>
                {[1, 2, 3, 4].map(idx => (
                    <StarIcon
                        key={`${team.id}-star${idx}`}
                        className={`icon fa-2x ${
                            userRating && userRating.rating >= idx
                                ? "rated"
                                : ""
                        } ${idx <= hoveredStars ? "hovered" : ""} ${
                            userRating &&
                            idx > hoveredStars &&
                            hoveredStars !== 0
                                ? "unrated"
                                : ""
                        }`}
                        onMouseEnter={() => setHoveredStars(idx)}
                        onMouseLeave={() => setHoveredStars(0)}
                        onClick={() => handleStarClick(team.id, idx)}
                    />
                ))}
            </div>
        </div>
    );
};

export default PlacementTeamHeader;
